import React from 'react';
import { useTranslation } from 'react-i18next';
import { SymbolDetailLabeledValue } from '../../../../symbol-detail/labeled-value/symbol-detail-labeled-value';
import { ValueAmount } from '../../../../value/amount/value-amount';

interface FairPriceTabPeStatsProps {
    currency: string;
    eps: number | null;
    peRatio: number | null;
}

export const FairPriceTabPeStats: React.FC<FairPriceTabPeStatsProps> = ({ currency, eps, peRatio }) => {
    const { t } = useTranslation();

    return (
        <div className="mb-medium rounded-medium border border-border px-small pb-small pt-medium">
            <div className="mb-medium text-[2.4rem] font-bold leading-[3.2rem] text-brand-secondary">
                {t('layout.dialogs.fairPrice.pe.defaultValues')}
            </div>
            <div className="grid gap-y-small gap-x-vlarge sm:grid-cols-2">
                <SymbolDetailLabeledValue
                    label={t('layout.dialogs.fairPrice.pe.eps')}
                    value={
                        eps !== null ? (
                            <ValueAmount mode="pure" amount={eps} currency={currency} fractionDigits={2} />
                        ) : (
                            '—'
                        )
                    }
                />
                <SymbolDetailLabeledValue
                    label={t('layout.dialogs.fairPrice.pe.peMultiple')}
                    value={peRatio !== null ? `${peRatio.toFixed(2)}x` : '—'}
                />
            </div>
        </div>
    );
};
